import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const SandGlassIllustration = ({ width = 29, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 40">
      <g fill="none" fillRule="evenodd">
        <path fill="#955D3F" d="M0 4.483L29 4.483 29 0 0 0zM0 40L29 40 29 35.517 0 35.517z" />
        <path
          fill="#EDEDED"
          d="M18.944 20c.044.018 7.434 3.04 7.434 15.474 0 .016-.008.038-.026.038l-9.981.004h-3.59L2.8 35.512c-.017 0-.026-.022-.026-.038 0-12.422 7.377-15.45 7.434-15.474h-.088S2.686 16.997 2.686 4.526c0-.016.008-.038.026-.038l10.212-.004h3.216l10.212.004c.018 0 .026.022.026.038 0 12.324-7.26 15.402-7.43 15.473z"
        />
        <path
          fill="#FFBF00"
          d="M23.634 10.491c.013 0 .019.01.019.017 0 5.32-6.082 6.602-6.082 6.602h-.011v7.913c.001 0 5.046 3.6 5.233 10.1l.005.37c0 .009-.006.02-.018.02l-5.93.003h-4.646l-5.929-.002c-.013 0-.019-.012-.019-.02 0-6.733 5.238-10.47 5.238-10.47V17.11s-6.083-1.282-6.083-6.602c0-.007.006-.017.019-.017l5.093-.001h8.018l5.093.001z"
        />
        <path
          fill="#000"
          d="M26.364 4.488c.018 0 .026.022.026.038C26.39 16.997 18.956 20 18.956 20h-.011c.086.036 7.433 3.076 7.433 15.474 0 .016-.008.038-.026.038l-9.981.004L29 35.517V40H14.532V20l.011-.001V4.483h1.609l10.212.005zM29 0v4.483H14.532V0H29z"
          opacity=".1"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
